export default __webpack_public_path__ + "static/media/Saly-12.6e08c19d.webp";